import { render, staticRenderFns } from "./PieChartTemplate.vue?vue&type=template&id=61ac1e48&scoped=true"
import script from "./PieChartTemplate.vue?vue&type=script&lang=js"
export * from "./PieChartTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ac1e48",
  null
  
)

export default component.exports